import { Head, Link } from "@inertiajs/react";
import { Card, Link as RadixLink } from "@radix-ui/themes";

import { AppLayout } from "@/components/app-layout";
import { ProjectForm } from "@/pages/projects/form";
import type { SharedProps } from "@/lib/types";

type UserOption = { id: number; email: string };
type GroupOption = { id: number; name: string };
type ProjectPayload = {
  id: number;
  name: string;
  status: string;
  project_group_id: number | null;
  project_owner_id: number;
  project_manager_id: number;
  frontend_lead_id: number;
  backend_lead_id: number;
  harvest_project_id: string | null;
  quickbooks_customer_id: string | null;
  asana_workspace_id: string | null;
  google_drive_folder_id: string | null;
  vcs_repository_links: string[];
};

type ProjectEditProps = SharedProps & {
  project: ProjectPayload;
  users: UserOption[];
  projectGroups: GroupOption[];
};

export default function ProjectsEdit({ auth, project, users, projectGroups }: ProjectEditProps) {
  return (
    <>
      <Head title={`Edit ${project.name}`} />
      <AppLayout
        user={auth.user}
        activeModule="weekly_planner"
        onModuleChange={() => {}}
        pageTitle="Edit Project"
        pageActions={
          <RadixLink asChild size="2">
            <Link href={`/projects/${project.id}`}>Back to project</Link>
          </RadixLink>
        }
      >
        <Card className="p-4">
          <ProjectForm
            action={`/projects/${project.id}`}
            method="patch"
            users={users}
            groups={projectGroups}
            initialValues={{
              name: project.name,
              status: project.status,
              project_group_id: project.project_group_id ? String(project.project_group_id) : "",
              project_owner_id: String(project.project_owner_id),
              project_manager_id: String(project.project_manager_id),
              frontend_lead_id: String(project.frontend_lead_id),
              backend_lead_id: String(project.backend_lead_id),
              harvest_project_id: project.harvest_project_id || "",
              quickbooks_customer_id: project.quickbooks_customer_id || "",
              asana_workspace_id: project.asana_workspace_id || "",
              google_drive_folder_id: project.google_drive_folder_id || "",
              vcs_repository_links: project.vcs_repository_links.join("\n"),
            }}
          />
        </Card>
      </AppLayout>
    </>
  );
}
